import React from 'react'
import { Box, Typography } from '@mui/material'
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import ContentPasteGoOutlinedIcon from '@mui/icons-material/ContentPasteGoOutlined';
const UserDetails = ({details}) => {

    const userLeadDetals = [
        {
            leadName: 'Lead Id',
            leadId:  details?.leadId
        },
        {
            leadName: 'Sign up Date & Time',
            leadId: `${details?.signUpDate || "-"} • ${details?.signUpTime || "-"}`
        },
        {
            leadName: 'Last login',
            leadId: `${details?.lastLoginDate || "-"} • ${details?.lastLoginAtTime || "-"}`
        },

    ]

    return (
        <>
            <Box sx={{ background: '#fff', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px;', padding: '25px', borderRadius: '14px' , marginBottom: '25px' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '30px' , flexWrap: 'wrap' , alignItems: 'center'}}>
                    <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center'  , flexWrap: 'wrap'}}>
                        <Box>
                            <Typography sx={{ background: '#007BE5', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize:{xl: '30px !important' , lg: '22px !important'}, width: {xl: '62px' , lg: '40px'}, height: {xl: '62px' , lg: '40px'}, borderRadius: '100%' }} variant='h4'>{details?.fullName?.slice(0,1) || "-"}</Typography>
                        </Box>
                        <Box>
                            <Box>
                                <Typography sx={{ fontSize: {xl: '18px' , lg: '16px'}, color: '#000', fontWeight: '500' }}>{details?.fullName}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                <Typography sx={{ fontSize: {xl: '12px' , lg: '12px'}, color: '#000', fontWeight: '400' }}><LocalPhoneOutlinedIcon sx={{ fontSize: {xl: '20px' , lg: '20px'} }} /> {details?.phone} </Typography>

                                <Typography sx={{ fontSize: {xl: '12px' , lg: '12px'}, color: '#000', fontWeight: '400' }}> <MailOutlinedIcon sx={{ fontSize: {xl: '20px' , lg: '20px'} }} /> {details?.email}</Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box>
                        <Box sx={{ display: 'flex', gap: '13px', alignItems: 'center', marginBottom: '13px', justifyContent: 'end' }}>
                            <Typography sx={{ fontSize: {xl: '18px' , lg: '14px'}, color: '#5F5F5F', fontWeight: '400' }}>Status</Typography>
                            <Typography sx={{ border: '1px solid #BDE3FF', borderRadius: '6px', color: '#007BE5', padding: {xl: '8px 12px' , lg: '4px 7px'},textTransform:'capitalize' }}>{details?.status}</Typography>
                        </Box>
                        <Box>
                            <Typography sx={{ color: '#858585', fontSize: {xl: '14px' , lg: '12px'}, fontWeight: '400' }}> <LanguageOutlinedIcon sx={{ color: '#345EFF', fontSize: {xl: '20px', lg: '14px' , marginBottom: '2px'}}} /> {details?.source}   <ContentPasteGoOutlinedIcon sx={{ color: '#345EFF' , fontSize: {xl: '20px', lg: '14px' , marginBottom: '2px'}}} />  </Typography>
                        </Box>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {
                        userLeadDetals.map(items => (

                            <Box>
                                <Typography sx={{ fontSize: {xl: '18px' , lg: '14px'}, color: '#1E1E1E', fontWeight: '500' }}>{items.leadName}</Typography>
                                <Typography sx={{ fontSize: {xl: '18px' , lg: '14px'}, color: '#5A5A5A', fontWeight: '400' }}>{items.leadId}</Typography>
                            </Box>
                        ))
                    }
                </Box>

            </Box>
        </>
    )
}

export default UserDetails